const VIN_LENGTH = 17;

const cellValue = (value: unknown) => String(value ?? '').trim();

export const normalizeVin = (value: unknown) => cellValue(value).toUpperCase();

export const isVinValue = (value: unknown) =>
  cellValue(value).length === VIN_LENGTH;

export const detectVinColumns = (
  headers: string[],
  rows: Record<string, unknown>[],
) =>
  headers.filter((header) => {
    const values = rows.map((row) => cellValue(row[header])).filter(Boolean);
    return (
      values.length > 0 && values.every((value) => value.length === VIN_LENGTH)
    );
  });

export const detectVinColumn = (
  headers: string[],
  rows: Record<string, unknown>[],
) => {
  const matches = detectVinColumns(headers, rows);
  return matches.length === 1 ? matches[0] : undefined;
};
